<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import ProfileCropper from "@/components/modals/profile-cropper.vue";
import ItemForm from "@/components/modals/item-form-modal.vue"

export default {
    components: {
        ProfileCropper,
        ItemForm
    },
    data() {
        return {
            title: "Items",
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: '',
            lazyFilter: '',
            filterOn: [],
            tableData: [],
            sortBy: "itemName",
            sortDesc: false,
            fields: [
                {
                    key: "profile",
                    sortable: false,
                    label: "Profile",
                    thStyle: { width: "80px" },
                    tdClass: "align-middle",
                },
                {
                    key: "itemName",
                    sortable: true,
                },
                {
                    key: "itemCategory",
                    sortable: true,
                    label: "Category",
                },
                {
                    key: "unit",
                    sortable: true,
                    label: "Unit",
                },
                {
                    key: "type",
                    sortable: true,
                    label: "Type",
                },
                {
                    key: "cost",
                    sortable: true,
                    label: "Unit Cost",
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            indexSelected: -1,
            tableBusy: false,
            profileTobeUpdated: null,
        };
    },
    computed: {
        filteredData() {
            let data = this.tableData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toLowerCase()
                        .includes(this.filter.toLowerCase());
                });
            }
            return data;
        },
        rows() {
            if (this.filter && this.filter.trim() != "") {
                return this.filteredData.length;
            }
            return this.tableData.length;
        },
    },
    created() {
        this.tableBusy = true;
        this.changeCycle(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    },
    methods: {
        changeCycle(cycle, campusId) {
            this.tableData = [];
            this.tableBusy = true;
            this.$store
                .dispatch("item/GetItemByCycle", {cycle, campusId})
                .then((res) => {
                    this.tableBusy = false;
                    res.data.forEach((item) => {
                        item.cost = this.formatCurrency(item.unitCost);
                        item.thumbnailUrl = item.thumbnail ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}` : '';
                        item.filterKey = `${item.itemName} ${item.description}`
                    });
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast(
                        "Something went wrong! - getting Item",
                        "error"
                    );
                });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addItem() {
            this.$refs.itemForm.putData({
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                itemCategoryId: "",
                unitCost: "",
                type: "",
                year: "",
                subType: "",
                isProcurable: true,
                inDbm: false,
                stockId: 0,
                formSubType: "",

            });
            this.modalTitle = "Create New Item";
            this.$bvModal.show("item-form-modal");
        },
        onCreate(modalData) {
            var data = cloneDeep(modalData);
            data.unitCost = this.getExactAmt(modalData.unitCost);
            data.campusId = this.$store.state.data.selectedCampus.id;
            if (modalData.id > 0) {
                this.$store
                    .dispatch("item/UpdateItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        data.filterKey = `${data.itemName} ${data.description}`;
                        data.cost = this.formatCurrency(data.unitCost);
                        let index = this.tableData.findIndex(x => x.id == data.id);
                        this.tableData.splice(index, 1, data);
                        this.$bvModal.hide("item-form-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong! - updating item", "error");
                    });
            } else {
                this.$store
                    .dispatch("item/CreateItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.filterKey = `${res.data.itemName} ${res.data.description}`;
                        res.data.cost = this.formatCurrency(res.data.unitCost);
                        this.tableData.push(res.data);
                        this.$bvModal.hide("item-form-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong! - creating item",
                            "error"
                        );
                    });
            }
        },
        updateItem(props) {
            let data = cloneDeep(props.item);
            data.stockId = props.item.stockId ?? 0;
            data.formSubType = props.item.subType;
            data.unitCost = props.item.unitCost.toString();
            data.unitFormName = props.item.unit.unitName;
            data.formItemCategory = props.item.itemCategory.name;
            data.formStockId = props.item.stockId;
            this.modalTitle = "Update Item";
            this.$refs.itemForm.putData(data);
            this.$bvModal.show("item-form-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("item/DeleteItem", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        updateProfile(row) {
            this.profileTobeUpdated = row;
            this.modalTitle = "Update Profile";
            this.$bvModal.show("upload-profile");
            this.$refs.profileCropper.imageUrl = "";
            this.$refs.profileCropper.cropImg = "";
            if(row.image){
                this.$refs.profileCropper.imageUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${row.image}`;
            }
        },
        async cropData(event) {
            if(this.profileTobeUpdated.thumbnailUrl !== ''){
                await this.$store
                .dispatch("filemanager/DeleteFileByReference", {
                    referenceId: this.profileTobeUpdated.id,
                    type: 'Item Profile',
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    this.$bvModal.hide("upload-profile");
                    this.showToast("Successfully updated!", "success");
                })
            }
            let fullData = {
                id: this.profileTobeUpdated.id,
                type: "Item Profile",
                folder: "Procurement",
                file: event.fullImg,
                description: "Original Image",
            };
            let fullUrl = "";
            let cropUrl = "";
            await this.$store
                .dispatch("filemanager/UploadFile", fullData)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    fullUrl = res.data.fileName;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            let croppedData = {
                id: this.profileTobeUpdated.id,
                type: "Item Profile",
                folder: "Procurement",
                file: event.cropImg,
                description: event.cropData,
            };
            await this.$store
                .dispatch("filemanager/UploadFile", croppedData)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    cropUrl = res.data.fileName;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            if(fullUrl === "" && cropUrl === ""){
                return this.showToast("Something went wrong!", "error");
            }
            let updateItem = {...this.profileTobeUpdated};
            delete updateItem.image;
            delete updateItem.thumbnail;
            let updateData = {
                image: fullUrl,
                thumbnail: cropUrl,
                ...updateItem,
            };
            this.$store
                .dispatch("item/UpdateItem", updateData)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.tableData.findIndex(x => x.id == this.profileTobeUpdated.id)
                    this.tableData[index].image = fullUrl;
                    this.tableData[index].thumbnail = cropUrl;
                    this.tableData[index].thumbnailUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${cropUrl}`;
                    this.$bvModal.hide("upload-profile");
                    this.showToast("Successfully uploaded!", "success");
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - updating item",
                        "error"
                    );
                });
        },
        uploadItem() {
            window.open( `/proc/item/excel-uploading`, "_blank");
        },
    },
};
</script>
<template>
    <div>
        <profile-cropper
            ref="profileCropper"
            @crop-picture="cropData"
        ></profile-cropper>
        <div class="row">
            <div class="col-12">
                <div class="card border">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">Item List</h4>
                            <div class="d-flex gap-2">
                                <button
                                    type="button"
                                    @click="uploadItem"
                                    class="
                                        btn btn-md btn-success
                                        d-flex
                                        align-items-center
                                    "
                                    v-if="$store.state.decrypt.isAdmin()"
                                >
                                    <i class="bx bx-upload fs-6"></i>Upload Excel
                                </button>
                                <button
                                    type="button"
                                    @click="addItem()"
                                    class="
                                        btn btn-md btn-info
                                        d-flex
                                        align-items-center
                                    "
                                >
                                    <i class="bx bx-plus fs-6"></i>Create New
                                </button>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select form-select-sm"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <form @submit.prevent="filter = lazyFilter">
                                    <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                    >
                                        <label
                                            class="d-inline-flex align-items-center"
                                        >
                                            Search:
                                            <b-form-input
                                                autocomplete="off"
                                                v-model="lazyFilter"
                                                type="search"
                                                placeholder="Search..."
                                                class="
                                                    form-control form-control-sm
                                                    ms-2
                                                "
                                            ></b-form-input>
                                        </label>
                                    </div>
                                </form>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="filteredData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :busy="tableBusy"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">
                                        {{ scope.emptyText }}
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(itemName)="row">
                                    <div>
                                        {{ row.value }}
                                    </div>
                                    <small>{{ row.item.description }}</small>
                                    <div>
                                        <span
                                            v-if="row.item.inDbm"
                                            class="
                                                me-2
                                                badge
                                                bg-primary bg-soft
                                            "
                                            >In DBM</span
                                        >
                                        <span
                                            v-if="row.item.isProcurable"
                                            class="badge bg-primary bg-soft"
                                            >Procurable</span
                                        >
                                    </div>
                                </template>
                                <template #cell(profile)="row">
                                    <a
                                        href="javascript:void(0);"
                                        @click="updateProfile(row.item)"
                                    >
                                        <div v-if="row.item.thumbnailUrl" class="d-flex justify-content-center">
                                            <img
                                                :src="row.item.thumbnailUrl"
                                                height="50"
                                                referrer-policy="no-referrer"
                                            />
                                        </div>
                                        <div
                                            v-else
                                            class="
                                                d-flex
                                                align-items-center
                                                justify-content-center
                                                bg-success bg-gradient
                                            "
                                            style="height: 50px"
                                        >
                                            <i
                                                class="
                                                    bx bx-user
                                                    text-white
                                                    font-size-24
                                                "
                                            ></i>
                                        </div>
                                    </a>
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="secondary"
                                                ><i
                                                    class="
                                                        mdi mdi-update
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                Total Items: {{ numberWithCommas(tableData.length) }}
                            </div>
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ItemForm ref="itemForm" @dropData="onCreate" :modalTitle="modalTitle"/>
    </div>
    
</template>